var map = {
	"./coldev/coldev.module": [
		"./src/app/coldev/coldev.module.ts",
		"default~coldev-coldev-module~unsyncdata-unsyncdata-module",
		"coldev-coldev-module"
	],
	"./colectionview/colectionview.module": [
		"./src/app/colectionview/colectionview.module.ts",
		"colectionview-colectionview-module"
	],
	"./collectionitems/collectionitems.module": [
		"./src/app/collectionitems/collectionitems.module.ts",
		"collectionitems-collectionitems-module"
	],
	"./confirminvoice/confirminvoice.module": [
		"./src/app/confirminvoice/confirminvoice.module.ts",
		"default~confirminvoice-confirminvoice-module~unsyncdata-unsyncdata-module",
		"confirminvoice-confirminvoice-module"
	],
	"./createcustomitem/createcustomitem.module": [
		"./src/app/createcustomitem/createcustomitem.module.ts",
		"createcustomitem-createcustomitem-module"
	],
	"./createcustomitemrandi/createcustomitemrandi.module": [
		"./src/app/createcustomitemrandi/createcustomitemrandi.module.ts",
		"createcustomitemrandi-createcustomitemrandi-module"
	],
	"./createcustomrandi/createcustomrandi.module": [
		"./src/app/createcustomrandi/createcustomrandi.module.ts",
		"createcustomrandi-createcustomrandi-module"
	],
	"./createcutomspecialitems/createcutomspecialitems.module": [
		"./src/app/createcutomspecialitems/createcutomspecialitems.module.ts",
		"createcutomspecialitems-createcutomspecialitems-module"
	],
	"./createlocalcustomer/createlocalcustomer.module": [
		"./src/app/createlocalcustomer/createlocalcustomer.module.ts",
		"createlocalcustomer-createlocalcustomer-module"
	],
	"./createlocalinvoice/createlocalinvoice.module": [
		"./src/app/createlocalinvoice/createlocalinvoice.module.ts",
		"createlocalinvoice-createlocalinvoice-module"
	],
	"./deliveryitemview/deliveryitemview.module": [
		"./src/app/deliveryitemview/deliveryitemview.module.ts",
		"deliveryitemview-deliveryitemview-module"
	],
	"./deliverymakepayment/deliverymakepayment.module": [
		"./src/app/deliverymakepayment/deliverymakepayment.module.ts",
		"default~deliverymakepayment-deliverymakepayment-module~unsyncdata-unsyncdata-module",
		"deliverymakepayment-deliverymakepayment-module"
	],
	"./deliveryview/deliveryview.module": [
		"./src/app/deliveryview/deliveryview.module.ts",
		"deliveryview-deliveryview-module"
	],
	"./driversummary/driversummary.module": [
		"./src/app/driversummary/driversummary.module.ts",
		"driversummary-driversummary-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./selectcategory/selectcategory.module": [
		"./src/app/selectcategory/selectcategory.module.ts",
		"selectcategory-selectcategory-module"
	],
	"./selectitemlist/selectitemlist.module": [
		"./src/app/selectitemlist/selectitemlist.module.ts",
		"selectitemlist-selectitemlist-module"
	],
	"./syncedinvoice/syncedinvoice.module": [
		"./src/app/syncedinvoice/syncedinvoice.module.ts",
		"syncedinvoice-syncedinvoice-module"
	],
	"./unsyncdata/unsyncdata.module": [
		"./src/app/unsyncdata/unsyncdata.module.ts",
		"default~coldev-coldev-module~unsyncdata-unsyncdata-module",
		"default~confirminvoice-confirminvoice-module~unsyncdata-unsyncdata-module",
		"default~deliverymakepayment-deliverymakepayment-module~unsyncdata-unsyncdata-module",
		"unsyncdata-unsyncdata-module"
	],
	"./viewmap/viewmap.module": [
		"./src/app/viewmap/viewmap.module.ts",
		"viewmap-viewmap-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;